export function os() {
	return uni.getSystemInfoSync().platform;
};

export function sys() {
	return uni.getSystemInfoSync();
}





// WEBPACK FOOTER //
// ./libs/function/sys.js